module.exports = __webpack_public_path__ + "img/login-icon.9ed10343.svg";